// src/pages/CategoryPage.js
import React, { useEffect, useState, Suspense, lazy } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import MenuPrincipal from "../components/menuPrincipal";
import api from '../redux/actions/configApi';
import { depoimentoSliderSettings } from '../config/sliderConfig'; // Ajuste o caminho conforme necessário
import LoadingOverlay from "../components/loading";
import WhatsApp from "../components/whatsApp";
import Rodape from "../components/rodape";
const BlogSection = lazy(() => import('../components/blogSection'));

const BlogIndex = () => {

    const [categorias, setCategorias] = useState([]);
    const [activeCategory, setActiveCategory] = useState('all');
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false); // Estado de carregamento

    const fetchCategories = async () => {
        try {
            const response = await api.get(`categories`);
            setCategorias(response?.data);
        } catch (error) {
            console.error("Erro ao buscar categorias:", error);
        }
    };

    const fetchAllPosts = async () => {
        try {
            setLoading(true)
            const response = await api.get(`postsAll`);
            setLoading(false)
            console.log(response?.data, 'posts')
            setPosts(response?.data);
            setActiveCategory('all'); // Define "Todos" como a categoria ativa
        } catch (error) {
            console.error("Erro ao buscar posts:", error);
        }
    };

    const fetchPostsByCategory = async (categoryId) => {
        try {
            setLoading(true)
            const response = await api.get(`postsCat/${categoryId}`);
            setPosts(response?.data);
            setActiveCategory(categoryId); // Atualiza a categoria ativa
            setLoading(false)
        } catch (error) {
            console.error("Erro ao buscar posts por categoria:", error);
        }
    };

    const handleAllCat = () => {
        setActiveCategory('all'); // Atualiza a categoria ativa
        fetchAllPosts();
    };

    const handleThemeClick = (category) => {
        fetchPostsByCategory(category.id);
    };

    useEffect(() => {
        fetchCategories();
        fetchAllPosts();
    }, []);
    
    return (
        <div>
            <MenuPrincipal />
            <div className="section-spacing-3">
                <div className={`box-2 loading ${loading ? 'loading-active' : ''}`}>
                    <LoadingOverlay loading={loading} />
                    <Container>
                        <div className='nav2'>
                            <Nav className="theme-menu d-flex justify-content-between align-items-center">
                                <Nav.Item className="theme-item">
                                    <div
                                        className={`theme-link ${activeCategory === 'all' ? 'active' : ''}`}
                                        onClick={handleAllCat}
                                        role="button"
                                    >
                                        Todos
                                    </div>
                                </Nav.Item>
                                {/* Mapeia as categorias disponíveis */}
                                {categorias?.map((category) => (
                                    <Nav.Item key={category.id} className="theme-item">
                                        <div
                                            className={`theme-link ${activeCategory === category.id ? 'active' : ''}`}
                                            onClick={() => handleThemeClick(category)}
                                            role="button"
                                        >
                                            {category.name}
                                        </div>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </div>
                        <section className='section-spacing shadow-lg bg-white rounded mt-5'>
                            <Suspense>
                                <BlogSection articles={posts} settings={depoimentoSliderSettings} titulo={''} size={'card-config'} link={1} disableAnimation={false} />
                            </Suspense>
                        </section>
                    </Container>
                </div>
            </div>
            <Rodape />
            <WhatsApp classe={'whatsapp-componente-flutuante'}/>
        </div>
    );
};

export default BlogIndex;
